import { withRouter } from "react-router";
import { compose, withProps, withState, lifecycle } from "recompose";

const withRefreshing = () =>
  compose(
    withRouter,
    withState(
      "isRefreshCleanedAfterMount",
      "setRefreshCleanedAfterMount",
      (props) => !props.location?.state?.refreshing
    ),
    withProps(({ location, isRefreshCleanedAfterMount }) => ({
      refreshing: isRefreshCleanedAfterMount && location?.state?.refreshing,
    })),
    lifecycle({
      componentDidMount() {
        if (!this.props.isRefreshCleanedAfterMount) {
          this.props.history.replace({
            ...this.props.location,
            state: {
              ...this.props.location.state,
              refreshing: undefined,
            },
          });
        }
      },
      componentDidUpdate() {
        if (!this.props.isRefreshCleanedAfterMount) {
          this.props.setRefreshCleanedAfterMount(true);
        } else if (this.props.refreshing) {
          document.body.classList.add("refreshing");
        } else {
          document.body.classList.remove("refreshing");
        }
      },
    })
  );

export default withRefreshing;
